const publicPaths = [
  /\/signin[^$]*$/,
  /\/signup[^$]*$/,
  /\/legal\/privacy-policy[^$]*$/,
  /\/legal\/terms-and-conditions[^$]*$/,
  /\/legal\/terms-of-use[^$]*$/,
  /\/confirm-invitation-employee/,
  /^\/book\/[^/]+\/meet-driver/,
];

export default publicPaths;
